module.exports = __webpack_public_path__ + "img/logo (2).56550cd0.png";